import {
  request2
} from './request'
// 我的学员列表
export function GetMyStudentsPage(params, studentIds = []) {
  let length1 = params.Source.length || 0
  let Ids1 = []
  for (let j = 0; j < length1; j++) {
    Ids1.push(params.Source[j][0])
  }
  return request2({
    url: `/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetMyStudentsPage/GetMyStudentsPage`,
    method: 'post',
    data: {
      studentIds: studentIds,
      keyWord: params.KeyWord,
      name: params.Name,
      tel: params.Tel,
      qqNumber: params.QqNumber,
      grade: params.Grade,
      studentIntent: params.StudentIntent,
      trackStartTime: params.TrackStartTime,
      trackEndTime: params.TrackEndTime,
      signUpStartTime: params.SignUpStartTime,
      signUpEndTime: params.SignUpEndTime,
      createStartTime: params.CreateStartTime,
      createEndTime: params.CreateEndTime,
      signUpState: params.SignUpState,
      source: Ids1,
      graduatedSchool: params.GraduatedSchool,
      graduatedMajor: params.GraduatedMajor,
      applySchool: params.ApplySchool,
      orderObject: params.OrderObject || 0,
      studentState: params.StudentState,
      orderByAsc: params.OrderByAsc,
      // ApplyMajor: params.ApplyMajor,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
    }
  })
}
// 获取学员下拉框数据源,如来源渠道,意向度,入学年份,英语基础,预报课程
export function GetBusinessStudentsSelectListData() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetBusinessStudentsSelectListData',
    method: 'get',
  })
}
// 待跟踪学员
export function GetToTrackStudents(params) {
  let length = params.StudentState.length || 0
  let Ids = ''
  for (let i = 0; i < length; i++) {
    if (i == length - 1) {
      Ids += `StudentState=${params.StudentState[i]}`
    } else {
      Ids += `StudentState=${params.StudentState[i]}&`
    }
  }
  return request2({
    url: `/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetToTrackStudentsPage?${Ids}`,
    method: 'get',
    params: {
      TrackDay: params.TrackDay,
      NextTrackDay: params.NextTrackDay,
      SwitckTrack: params.SwitckTrack,
      SwitckNextTrack: params.SwitckNextTrack,
      KeyWord: params.KeyWord,
      Name: params.Name,
      Tel: params.Tel,
      QqNumber: params.QqNumber,
      Grade: params.Grade,
      StudentIntent: params.StudentIntent,
      TrackStartTime: params.TrackStartTime,
      TrackEndTime: params.TrackEndTime,
      SignUpStartTime: params.SignUpStartTime,
      SignUpEndTime: params.SignUpEndTime,
      CreateStartTime: params.CreateStartTime,
      CreateEndTime: params.CreateEndTime,
      Source: params.Source,
      GraduatedSchool: params.GraduatedSchool,
      GraduatedMajor: params.GraduatedMajor,
      ApplySchool: params.ApplySchool,
      ApplyMajor: params.ApplyMajor,
      PageIndex: params.PageIndex,
      PageSize: params.PageSize,
      OrderObject: params.OrderObject,
      OrderByAsc: params.OrderByAsc,

    }
  })
}
// 即入公海库学员
export function GetEnterSighSeasVaultStudents(params) {
  let length = params.StudentState.length || 0
  let Ids = ''
  for (let i = 0; i < length; i++) {
    if (i == length - 1) {
      Ids += `StudentState=${params.StudentState[i]}`
    } else {
      Ids += `StudentState=${params.StudentState[i]}&`
    }
  }
  return request2({
    url: `/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetEnterSighSeasVaultStudentsPage?${Ids}`,
    method: 'get',
    params: {
      countdownTime: params.countdownTime,
      TrackDay: params.TrackDay,
      NextTrackDay: params.NextTrackDay,
      SwitckTrack: params.SwitckTrack,
      SwitckNextTrack: params.SwitckNextTrack,
      KeyWord: params.KeyWord,
      Name: params.Name,
      Tel: params.Tel,
      QqNumber: params.QqNumber,
      Grade: params.Grade,
      StudentIntent: params.StudentIntent,
      TrackStartTime: params.TrackStartTime,
      TrackEndTime: params.TrackEndTime,
      SignUpStartTime: params.SignUpStartTime,
      SignUpEndTime: params.SignUpEndTime,
      CreateStartTime: params.CreateStartTime,
      CreateEndTime: params.CreateEndTime,
      Source: params.Source,
      GraduatedSchool: params.GraduatedSchool,
      GraduatedMajor: params.GraduatedMajor,
      ApplySchool: params.ApplySchool,
      ApplyMajor: params.ApplyMajor,
      PageIndex: params.PageIndex,
      PageSize: params.PageSize,
      OrderObject: params.OrderObject,
      OrderByAsc: params.OrderByAsc,

    }
  })
}


// 公海库学员
export function GetPublicLibraryStudentsPage(params) {
  // let length = params.Source.length || 0
  let Ids = ''
  let StudentIds = ''
  let pageIndex = params.pageIndex || 1
  // for (let i = 0; i < length; i++) {
  //   if (i == length - 1) {
  //     Ids += `Source=${params.Source[i]}`
  //   } else {
  //     Ids += `Source=${params.Source[i]}&`
  //   }
  // }
  if (params.Source&&params.Source.length!=0) {
    Ids += `&Source=${params.Source}`
  }
  if (params.StudentIds&&params.StudentIds.length) {
    params.StudentIds.forEach((item, index) =>{
      if (index === params.StudentIds.length - 1) {
        StudentIds += `StudentIds=${item}`
      } else {
        StudentIds += `StudentIds=${item}&`
      }
    })
  }
  delete params.StudentIds
  delete params.pageIndex
  return request2({
    url: `/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetPublicLibraryStudentsPage?pageIndex=${pageIndex}${Ids}&${StudentIds}`,
    method: 'get',
    params: params
  // {
  //     Name: params.Name,
  //     Tel: params.Tel,
  //     WeiXinNumber: params.WeiXinNumber,
  //     GraduatedSchool: params.GraduatedSchool,
  //     GraduatedMajor: params.GraduatedMajor,
  //     ApplySchool: params.ApplySchool,
  //     ApplyMajor: params.ApplyMajor,
  //     ToDealWithState: params.ToDealWithState,
  //     OutPublicStartTime: params.OutPublicStartTime,
  //     OutPublicEndTime: params.OutPublicEndTime,
  //     WhyNote: params.WhyNote,
  //     OrignalBusinessId: params.OrignalBusinessId,
  //     Grade: params.Grade,
  //     StudentIntent: params.StudentIntent,
  //     BeginCreateTime: params.BeginCreateTime,
  //     EndCreateTime: params.EndCreateTime,
  //     pageIndex: params.pageIndex,
  //     pageSize: params.pageSize,
  //   },
  })
}
// 公海库学员：学员处理状态
export function GetPublicStudentStateList() {
  return request2({
    url: `/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetPublicStudentStateList`,
    method: 'get',
  })
}
// 公海库学员：设为咨询中
export function SetPublicStudentToConsultation(publicRecodId) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/BusinessStudentAdmin/SetPublicStudentToConsultation',
    method: 'post',
    params: {
      publicRecodId,
    }
  })
}
// 公海库学员：处理学员
export function SetPublicStudentState(params) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/BusinessStudentAdmin/SetPublicStudentState',
    method: 'post',
    params: {
      publicRecodId: params.publicRecodId,
      state: params.state,
      desp: params.desp,
    }
  })
}

// 已报名学员
export function GetHaveSignUpStudentsPage(studentIds, params) {
  let length1 = params.Source.length || 0
  let Ids1 = []
  for (let j = 0; j < length1; j++) {
    Ids1.push(params.Source[j][0])
  }
  return request2({
    url: `/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetHaveSignUpStudentsPage`,
    method: 'post',
    data: {
      studentIds: studentIds,
      name: params.Name,
      tel: params.Tel,
      qNumber: params.QqNumber,
      handoverId: params.HandoverId,
      weiXinNumber: params.WeiXinNumber,
      applySchool: params.ApplySchool,
      applyMajor: params.ApplyMajor,
      signUpStartTime: params.SignUpStartTime,
      signUpEndTime: params.SignUpEndTime,
      source: Ids1,
      pageIndex: params.PageIndex,
      pageSize: params.PageSize,
    }
  })
}

// 待接入学员
export function GetToAccessStudentsPage(params) {
  let length = params.Source.length > 0 ? params.Source.length : 0
  let Ids = ''
  for (let i = 0; i < length; i++) {
    if (i == length - 1) {
      Ids += `Source=${params.Source[i]}`
    } else {
      Ids += `Source=${params.Source[i]}&`
    }
  }
  return request2({
    url: `/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetToAccessStudentsPage?${Ids}`,
    method: 'get',
    params: {
      ToDealWithState: params.ToDealWithState,
      ToDealWithMemberId: params.ToDealWithMemberId,
      KeyWord: params.KeyWord,
      BusinessId: params.BusinessId,
      Name: params.Name,
      Tel: params.Tel,
      QqNumber: params.QqNumber,
      Grade: params.Grade,
      StudentIntent: params.StudentIntent,
      GraduatedSchool: params.GraduatedSchool,
      GraduatedMajor: params.GraduatedMajor,
      ApplySchool: params.ApplySchool,
      // StudentState: params.StudentState,
      ApplyMajor: params.ApplyMajor,
      OrderObject: params.OrderObject,
      OrderByAsc: params.OrderByAsc,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
    },
  })
}
// 待接入学员
export function SetToAccessStudentState(studentId) {
  // let length = params.Source.length > 0 ? params.Source.length : 0
  // let Ids = ''
  // for (let i = 0; i < length; i++) {
  //   if (i == length - 1) {
  //     Ids += `Source=${params.Source[i]}`
  //   } else {
  //     Ids += `Source=${params.Source[i]}&`
  //   }
  // }
  return request2({
    url: `/api2/TZsbAdminStudentApi/BusinessStudentAdmin/SetToAccessStudentState?studentId=${studentId}`,
    method: 'post',
    // data: {
    //   studentId
    // },
  })
}
// 批量设置学员状态为不报了
export function SetStudentStateToNoSignUp(ids) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/BusinessStudentAdmin/SetStudentStateToNoSignUp',
    method: 'post',
    data: ids
  })
}
// 学员联系方式校验
export function CheckStudentInfo(params) {
  return request2({
    url: `/api2/TZsbAdminStudentApi/StudentAdmin/CheckStudentInfo`,
    method: 'post',
    data: {
      id: params.studentId,
      type: params.type,
      telPhone: params.telPhone,
      weiXinNumber: params.weiXinNumber,
      qqNumber: params.qqNumber,
      businessId: params.businessId,
    },
  })
}

// 我的学员列表新
export function GetMyStudentsPageNew(params, studentIds = []) {
  let length1 = params.Source.length || 0
  let Ids1 = []
  for (let j = 0; j < length1; j++) {
    Ids1.push(params.Source[j][0])
  }
  return request2({
    url: `/api2/TZsbAdminStudentApi/BusinessStudentAdminV2/GetMyStudentsPage`,
    method: 'post',
    data: {
      studentIds: studentIds,
      keyWord: params.KeyWord,
      name: params.Name,
      tel: params.Tel,
      qqNumber: params.QqNumber,
      grade: params.Grade,
      studentIntent: params.StudentIntent,
      trackStartTime: params.TrackStartTime,
      trackEndTime: params.TrackEndTime,
      signUpStartTime: params.SignUpStartTime,
      signUpEndTime: params.SignUpEndTime,
      createStartTime: params.CreateStartTime,
      createEndTime: params.CreateEndTime,
      signUpState: params.SignUpState,
      source: Ids1,
      graduatedSchool: params.GraduatedSchool,
      graduatedMajor: params.GraduatedMajor,
      applySchool: params.ApplySchool,
      orderObject: params.OrderObject || 0,
      studentState: params.StudentState,
      orderByAsc: params.OrderByAsc,
      // ApplyMajor: params.ApplyMajor,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
    }
  })
}

// 批量设置学员状态为不报了
export function GetProcessingRecordByStudentId(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/ProcessingRecordAdmin/GetProcessingRecordByStudentId',
    method: 'get',
    params: obj
  })
}

// 获取已存在微信号的微信id与所属网络营销老师、所属用户运营老师、所属招生老师是否已加好友 /TZsbAdminWeiXinApi/ChatRecord/GetContactStates
export function GetContactStates(obj) {
  return request2({
    url: '/api2/TZsbAdminWeiXinApi/ChatRecord/GetContactStates',
    method: 'get',
    params: obj
  })
}

// 获取指定学员与老师的聊天数目 /TZsbAdminWeiXinApi/ChatRecord/GetChatReocrdCount
export function GetChatReocrdCount(obj) {
  return request2({
    url: '/api2/TZsbAdminWeiXinApi/ChatRecord/GetChatReocrdCount',
    method: 'get',
    params: obj
  })
}